import React from 'react';
import { WebinarLink } from './WebinarLink';
export const Header = ({
  openModal
}) => {
  // Replace 'webinar' with WebinarLink component in text
  const replaceWebinarWithLink = text => {
    const parts = text.split(/(\bwebinar\b)/i);
    return parts.map((part, index) => {
      if (part.toLowerCase() === 'webinar') {
        return <WebinarLink key={index} onClick={openModal} data-id="element-93">
            webinar
          </WebinarLink>;
      }
      return part;
    });
  };
  return <header className="mb-8" data-id="element-94">
      <div className="flex items-center justify-center mb-4" data-id="element-95">
        <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/6YKzftRpGkz4jKTtn8FQxB/Logo_Stressless_Dogs_%288%29_%284%29.png" alt="Stressless Dogs Logo" className="h-16 object-contain" data-id="element-96" />
      </div>
      <a href="https://stresslessdogs.nl/mcc-meta-adv2" className="text-center block mb-6 bg-blue-50 p-3 rounded-lg border-2 border-blue-300 cursor-pointer hover:bg-blue-100 transition-colors" target="_blank" rel="noopener noreferrer" data-id="element-97">
        <p className="font-bold text-blue-700" data-id="element-98">
          GRATIS WEBINAR VAN HONDEN GEDRAGSEXPERT - VANDAAG & MORGEN
        </p>
      </a>
      <h1 className="text-2xl md:text-3xl font-bold text-center mb-6 text-blue-800 leading-tight" data-id="element-99">
        Van frustratie naar harmonie in 90 minuten: hoe 100.000+ baasjes in 2024
        de geheime taal van hun hond leerden spreken
      </h1>
      <div className="text-center mb-4 text-blue-600 font-semibold" data-id="element-100">
        In slechts 90 minuten leer je eindelijk begrijpen wat je hond al maanden
        probeert te zeggen
      </div>
      <div className="text-center text-sm text-gray-600 mb-6" data-id="element-101">
        Door Amee de Bruijn, Gediplomeerd Hondengedragsconsultant
      </div>
      <div className="w-full mb-6" data-id="element-102">
        <a href="https://stresslessdogs.nl/mcc-meta-adv2" target="_blank" rel="noopener noreferrer" data-id="element-103">
          <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/inDJ1aV7dcBAqLoekugSLb/Scherm_afbeelding_2025-08-21_om_23.44.08-min.png" alt="Vrouw en haar hond tijdens een wandeling" className="w-full h-auto rounded-lg shadow-md cursor-pointer" data-id="element-104" />
        </a>
        <p className="text-xs text-gray-500 mt-1 text-center italic" data-id="element-105">
          Soms kan anderhalf uur alles veranderen in de relatie met je hond
        </p>
      </div>
      <div className="w-full h-[1px] bg-gray-200 my-6" data-id="element-106"></div>
    </header>;
};